import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MapControl } from "../../../MapControl";
import { MeasurerTool } from "./MeasurerTool";
import { BaseMapTool } from "./BaseMapTool";
export const ToolsControl = ({ measurerDisabled, ...props }) => {
    return (_jsxs(MapControl, { ...props, column: true, children: [_jsx(BaseMapTool, {}), _jsx(MeasurerTool, { disabled: measurerDisabled })] }));
};
